/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { CertificateByOrganizationCertificateRequestDto } from "./CertificateByOrganizationCertificateRequestDto.ts"
import type { CertificateCreatedByDto } from "./CertificateCreatedByDto.ts"
import type { CertificateRequestPurchaseOrderDto } from "./CertificateRequestPurchaseOrderDto.ts"
import type { CertificateTypeDto } from "./CertificateTypeDto.ts"
import type { ProductionSiteWithOrganizationDto } from "./ProductionSiteWithOrganizationDto.ts"

export const certificateByOrganizationDtoStatusEnum = {
  NOT_UPLOADED: "NOT_UPLOADED",
  PENDING: "PENDING",
  PROCESSED: "PROCESSED",
  REJECTED: "REJECTED",
} as const

export type CertificateByOrganizationDtoStatusEnumKey =
  (typeof certificateByOrganizationDtoStatusEnum)[keyof typeof certificateByOrganizationDtoStatusEnum]

export const certificateByOrganizationDtoExtractionOutcomeEnum = {
  AUTO_ACCEPTED: "AUTO_ACCEPTED",
  NEEDS_MANUAL_REVIEW: "NEEDS_MANUAL_REVIEW",
  EXTRACTION_FAILED: "EXTRACTION_FAILED",
} as const

export type CertificateByOrganizationDtoExtractionOutcomeEnumKey =
  (typeof certificateByOrganizationDtoExtractionOutcomeEnum)[keyof typeof certificateByOrganizationDtoExtractionOutcomeEnum]

export const certificateByOrganizationDtoReviewReasonEnum = {
  TYPE_MISMATCH: "TYPE_MISMATCH",
  UNSUPPORTED_TYPE: "UNSUPPORTED_TYPE",
  LOW_QUALITY: "LOW_QUALITY",
  EXTRACTION_EMPTY: "EXTRACTION_EMPTY",
} as const

export type CertificateByOrganizationDtoReviewReasonEnumKey =
  (typeof certificateByOrganizationDtoReviewReasonEnum)[keyof typeof certificateByOrganizationDtoReviewReasonEnum]

export type CertificateByOrganizationDto = {
  /**
   * @type string
   */
  id: string
  /**
   * @type string
   */
  name: string
  /**
   * @type string, date-time
   */
  createdAt: Date
  /**
   * @type string
   */
  status: CertificateByOrganizationDtoStatusEnumKey
  /**
   * @type string
   */
  businessPartner: string
  /**
   * @type string
   */
  certificateRequestStatus: string
  /**
   * @type object
   */
  type: CertificateTypeDto
  /**
   * @type string
   */
  documentId: string
  /**
   * @type string
   */
  reference: string | null
  /**
   * @type object
   */
  productionSite: ProductionSiteWithOrganizationDto
  /**
   * @type string
   */
  certificationBody: string | null
  /**
   * @type string
   */
  certifiedOrganizationName: string | null
  /**
   * @type string
   */
  certifiedOrganizationAddress: string | null
  /**
   * @type string
   */
  certifiedOrganizationLicenseNumber: string | null
  /**
   * @type string
   */
  certifiedWeight: string | null
  /**
   * @type string
   */
  linkedScopeCertificateNumber: string | null
  /**
   * @type array
   */
  processingSteps: string[]
  /**
   * @type array
   */
  productCategories: string[]
  /**
   * @type array
   */
  productDetails: string[]
  /**
   * @type string, date-time
   */
  issueDate: Date | null
  /**
   * @type string, date-time
   */
  expiryDate: Date | null
  /**
   * @type string
   */
  score: string | null
  /**
   * @type string
   */
  buyerOfCertifiedProducts: string | null
  /**
   * @type object
   */
  purchaseOrders: CertificateRequestPurchaseOrderDto
  /**
   * @type array
   */
  certificateRequests: CertificateByOrganizationCertificateRequestDto[]
  /**
   * @type object
   */
  createdBy: CertificateCreatedByDto
  /**
   * @type string
   */
  extractionOutcome: CertificateByOrganizationDtoExtractionOutcomeEnumKey | null
  /**
   * @type string
   */
  reviewReason: CertificateByOrganizationDtoReviewReasonEnumKey | null
}
